import { faBriefcase, faGraduationCap } from "@fortawesome/free-solid-svg-icons";



function useResumeData() {

    const resumeData = [
    {
        year: "Corewell Health: 2020 - Present",
        title: "Software Developer - Intermediate",
        description: "Technical Contributions",
        additionalDescription: "Project Management and Leadership",
        summary: [
            "Contributed to the development of a user-friendly web platform enabling members to seamlessly access their health plan information",
            "Supported web application front-end using Angular , HTML , CSS , and Angular MaterialUI",
            "Maintained PriorityHealth.com, a cloud-backed static site powered by AWS, Contentstack, React, and Gatsby",
            "Built an AWS Textract pipeline to extract CPT codes from 450+ PDFs, automating workflows for content editors and improving data accuracy",
            "Supported and collaborated on .NET APIs that facilitated smooth communication with our Angular front-end interface",
            "Implemented unit testing with Jasmine to enhance code quality and reliability",
            "Used Bitbucket/Git for version control",
            "Led the revamp and enhancement of the PH iOS application, serving over 241,000 users with improved functionality and user experience",
            "Integrated OAuth 2.0 protocol to optimize and streamline the user login process, improving security and ease of access",
            "Rebuilt biometric login functionality, increasing stability and reliability for users",
            "Implemented Single Sign-On (SSO) capabilities to enable seamless authentication with third-party vendors"],
        additionalSummary: [
            "Oversaw the execution of concurrent projects, ensuring timely delivery by coordinating with developers, designers, and stakeholders while adhering to HIPAA regulations to maintain data privacy and compliance throughout the development process",
            "Implemented Agile methodologies to enhance project workflows, collaborating with technical leads to refine scope and timelines",
            "Led cross-functional teams to enhance user experience of the PH iOS application, resulting in an App Store rating increase from 1.9 to 4.6 stars",
            "Mentored two interns, providing guidance on projects and professional development",
            "Facilitated lunch and learns and knowledge sharing sessions to promote continuous learning within the development team"
        ],
        icon: faBriefcase,
    },

    {
        year: "Steelcase Inc: 2019 - 2020",
        title: "Web and Mobile Developer",
        description: "Order Management and Scheduling IT intern",
        additionalDescription: "Innovation Management Office Intern",
        summary: [
            "Used JavaScript , SAPUI5 , ABAP , oData , and Fiori LaunchPad to develop an SAP web application used globally by Steelcase’s Order Fulfillment Consultants"],
            additionalSummary: [
                "Developed unique proof of concepts focused on IoT, web development, and mobile development",
                "Developed a maker portal using Ruby on Rails and MongoDB, enabling creators to seamlessly submit ideas, research, and projects",
                "Collaborated on a React Native application to digitize inventory management processes for manufacturing plants, enhancing efficiency and accuracy",
                "Applied design thinking methodologies to empathize with users, ideate solutions, and deliver prototypes that inspired design",
            ],
        icon: faBriefcase,
    },
    {
        year: "2020",
        title: "Graduated from Calvin University",
        description: "Bachelor's in Computer Science, Minor in Political Science",
        icon: faGraduationCap,
    },


];

return resumeData;

}
export default useResumeData;